module.exports = __webpack_public_path__ + "img/3a6f76b4399d8721b19517509a26a429.png";